import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'

const ButtonCont = styled.button`
  color: #ffffff;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
  background-color: ${props => props.background || '#003399'};
  border: 0;
  font-family: Roboto;
  color: ${props => props.color || '#f7f7f9'};
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  margin: 0 auto;
  margin-top: 30px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
  outline: none;
  padding: ${props =>
    (props.size === 'small' && '2px 15px') ||
    (props.size === 'medium' && '6px 20px') ||
    (props.size === 'large' && '16px 30px')};

  &:hover {
    background: rgb(1, 58, 175);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }
  &:focus {
    background: rgb(76, 113, 184);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }
  &:active {
    background: rgb(75, 112, 183);
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  }

  &:last-child {
    margin-right: 0;
  }

  :disabled {
    background: gray;
  }
`
function Button({ size, children, onClick, ...props }) {
  return (
    <ButtonCont
      size={size}
      {...props}
      onClick={event => {
        onClick(event)
      }}
    >
      {children}
    </ButtonCont>
  )
}

Button.propTypes = {
  size: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  props: PropTypes.array
}

export default Button
